import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/katzya/Navbar";
import Hero from "@/components/katzya/Hero";
import Marquee from "@/components/katzya/Marquee";
import About from "@/components/katzya/About";
import Services from "@/components/katzya/Services";
import Plans from "@/components/katzya/Plans";
import Portfolio from "@/components/katzya/Portfolio";
import Team from "@/components/katzya/Team";
import Contact from "@/components/katzya/Contact";
import Footer from "@/components/katzya/Footer";
import KickstartPopup from "@/components/katzya/KickstartPopup";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App noise-overlay paper-grid" data-testid="katzya-app">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <Plans />
          <Portfolio />
          <Team />
          <Contact />
        </main>
        <Footer />
        <KickstartPopup />
        <Toaster position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
